import type { PhxBenefitsPlan } from '../../../generated/graphql';

export const isPhxBenefitsPlan = (plan: {
    __typename?: string;
}): plan is PhxBenefitsPlan => plan.__typename === 'PhxBenefitsPlan';
